export class RecapPremiumDialogController {
    public static $inject: string[] = ["$mdDialog"];

    constructor(private $mdDialog: ng.material.IDialogService) {}

    public closeDialog() {
        this.$mdDialog.hide();
    }
}
